import { useEffect, useState } from "react";
import HxfIonPopup from "../../../../../../../CustomElements/ProductionUI/HxfIonPopup/HxfIonPopup";
import { useProductionOrderSelectionStore } from "../../../../../../ProductionOrders/Standard/store/productionOrderSelectionStore";
import useHxfTranslation from "../../../../../../../../barrel/hooks/useHxfTranslation";
import { IonButton, IonIcon } from "@ionic/react";
import styles from "./PreOpenRedirView.module.scss";
import productionOrdersController from "../../../../../../../../barrel/controllers/productionOrdersController";
import { useHistory } from "react-router";
import useFeedbackService from "../../../../../../../../barrel/hooks/useFeedbackService";
import HxfOverlayLoading from "../../../../../../../CustomElements/HxfOverlayLoading/HxfOverlayLoading";
import HxfIonLoading from "../../../../../../../CustomElements/HxfIonLoading/HxfIonLoading";
interface IProps{
    onClose:any;
    objSelected:any;
    onSelectCurrentProduct?:any;
    Id_ProductionOrder_Product?:any,
}
function PreOpenRedirView(props:IProps){

    const [didMount, setDidMount] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const feedbackService = useFeedbackService();
    const {t} = useHxfTranslation();
    const productionOrderSelectionStore = useProductionOrderSelectionStore();
    const history = useHistory();


    const getLayoutIdentifier = () => {
     
        //return "SIMILAR_NAME_POP_SAME_OPERATION"; //currently only have one layout implemented
        return props?.objSelected?.shopfloorSetting_preOpenRedir_lyt;
    }

    function continueToAlternativeProduct(){
        let operationCode = props.objSelected.code;
        let productId = props?.objSelected?.Id_Product;
        let originalProductName = productionOrderSelectionStore.product.name;
        let opts = {
            modeCleanup: "POPS_SELECTION",
            includePopDataByPopId:"ALL",
            includeOperationCode: true
        };
        setIsLoading(true);
        let productionOrderId = productionOrderSelectionStore?.productionOrder?.Id;
        productionOrdersController().getProductionOrderById(
            productionOrderId,
            opts,
            null
          ).then((resp: any) => {
            setIsLoading(false);
            let poData = resp?.data?.response?.data;
            
            if (!poData) {
              throw "unexpected poData";
            }

            let productionOrderProducts = poData?.productionOrderProducts ? poData.productionOrderProducts : [];

            let selectedPopCandidate = null;
            //find pop starting with same name as original product
            for(let i = 0; i<productionOrderProducts.length; i++){
                if(productionOrderProducts[i].Id === props.Id_ProductionOrder_Product){
                    continue;
                }
                let candidateName = productionOrderProducts[i].name;
                if(candidateName.startsWith(originalProductName)){
                    //search for matching operation
                    let operationsData = productionOrderProducts[i].operationsData;
                    for(let j = 0; j<operationsData.length; j++){
                        let candidateOperationCode = operationsData[j].code;
                        if(candidateOperationCode === operationCode){
                            selectedPopCandidate = productionOrderProducts[i];
                            break;
                        }
                    }
                   
                }
            }
            //redirect to the other pop, and send state to click
            if(selectedPopCandidate){
                history.push({
                    pathname: "/page-redirector",
                    state: { 
                        redirectTo:"/feature/production-order/" + productionOrderId + "/po-product/" + selectedPopCandidate.Id,
                        withHistoryState:{
                            autoSelectOperation:operationCode,
                            onPreActionsOperationCloseGoBack:true
                        }
                     },
                });
            }else{
                setIsLoading(false);
                //produto alvo nao foi encontrado nos produtos desta ordem de produçao
                feedbackService.notifyToast(t('target.product.not.found.in.pops'),"danger");
                props.onClose();
            }
          }).catch((res:any) => {
            setIsLoading(false);
            feedbackService.notifyToast(t('error.unexpected'),"danger");
            props.onClose();
          });
    }

    useEffect(() => {
        if(!didMount){

            if(!getLayoutIdentifier()){
                continueToAlternativeProduct();
            }
            setDidMount(true);
        }
    
    },[didMount]);




    if(!getLayoutIdentifier()){

        return (
            <>
                <HxfOverlayLoading/>
            </>
        )
    }

    return (
        <HxfIonPopup title={t('select.an.option')} onClose={() => {
            props.onClose();
        }}
        modelSettings={{
            customPopupMaxHeight:'400px',
            customPopupMaxWidth:'400px'
        }}
        content={(
            <>
            {isLoading && (
                <HxfOverlayLoading/>
            )}
                {getLayoutIdentifier() === "TESTER_OR_ORIGINAL" && (
                    <div style={{display:'flex',justifyContent:'center',alignItems:'center',height:'100%'}}>
                        <div className={styles.lytTOOMsg}>
                            {t('would.you.like.to.work.on.tester.or.original')}
                        </div>
                    </div>
                )}
            </>
   
        )} bottomConfirmationContainer={(
            <>
                <div className={styles.lytConfirmationBtns}>
                    <div className={styles.confirmButtonContainer}>
                        <IonButton
                            color="warning"
                            className={styles.confirmButton}
                            onClick={() => {
                                
                                continueToAlternativeProduct();
                            }}>
                            <div>{t('tester')}</div>
                        </IonButton>
                    </div>

                    <div className={styles.confirmButtonContainer}>
                        <IonButton
                         
                            className={styles.confirmButton}
                            style={{maxWidth:'200px'}}
                            onClick={() => {
                                if(props.onSelectCurrentProduct){       
                                    props.onSelectCurrentProduct();
                                }
                               
                            }}>
                            <div>{t('original')}</div>
                        </IonButton>
                    </div>
                </div>
            </>
        )}/>
    )
}

export default PreOpenRedirView;